<template>
  <b-modal id="confirm-modal" v-model="auxValue" :width="400">
    <div class="modal-card-body has-text-centered">
      <h3 class="modal-title">¿Seguro?</h3>
      <div class="modal-content">
        <p>
          Hay <span class="has-text-weight-bold">{{ numberOfAccountableEntities }}</span>
          registro{{ numberOfAccountableEntities > 1 ? 's' : '' }}
          que se marcará{{ numberOfAccountableEntities > 1 ? 'n' : '' }}
          como contabilizado{{ numberOfAccountableEntities > 1 ? 's' : '' }}.
        </p>
      </div>
      <div class="modal-footer columns">
        <div class="column">
          <p class="control">
            <button class="button is-button-secondary is-rounded" @click="auxValue = false">
              Cancelar
            </button>
          </p>
        </div>
        <div class="column">
          <p class="control">
            <button
              id="confirm-to-account-button"
              class="button is-button-primary is-rounded"
              :disabled="accountingButtonDisabled"
              @click="$emit('account')">
              Confirmar
            </button>
          </p>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    numberOfAccountableEntities: { type: Number, default: 0 },
    accountingButtonDisabled: { type: Boolean, default: true }
  },
  data() {
    return {
      auxValue: false
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.auxValue = val;
      }
    },
    auxValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
<style scoped>
.modal-footer {
  margin-bottom: 30px;
  font-size: 12px;
}
</style>
